import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import AuthenticationService from '../service/AuthenticationService';
import EventBus from "../common/EventBus";
import CompanyService from '../service/CompanyService';
//import { useHistory } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import utils from '../constants/utils';
import AccountService from '../service/AccountService';
import AuthService from '../security/AuthService';
import PasswordChecklist from "react-password-checklist"
import Constants from '../constants/Constants';
import { InputTextarea } from 'primereact/inputtextarea';

import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import FileService from '../service/FileService';
import { RadioButton } from 'primereact/radiobutton';
import { ConfirmDialog } from 'primereact/confirmdialog';

const CustomConfirmDialog = (props) => {
    console.log("CustomConfirmDialog props: ", props);

    const toast = useRef(null);

    const navigate = useNavigate();
    const { t } = useTranslation();

    const accept = () => {
      //  toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    };

    const reject = () => {
        //toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    };

  
    return (
       
            <ConfirmDialog
                group="headless"
                content={({ headerRef, contentRef, footerRef, hide, message }) => (
                    <div className="flex flex-column align-items-center p-5 surface-overlay border-round">
                        <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                            <i className="pi pi-question text-5xl"></i>
                        </div>
                        <span className="font-bold text-2xl block mb-2 mt-4" ref={headerRef}>
                            {message.header}
                        </span>
                        <p className="mb-0" ref={contentRef}>
                            {message.message}
                        </p>
                        <div className="flex align-items-center gap-2 mt-4" ref={footerRef}>
                            <Button
                                label="Save"
                                onClick={(event) => {
                                    hide(event);
                                    accept();
                                }}
                                className="w-8rem"
                            ></Button>
                            <Button
                                label="Cancel"
                                outlined
                                onClick={(event) => {
                                    hide(event);
                                    reject();
                                }}
                                className="w-8rem"
                            ></Button>
                        </div>
                    </div>
                )}
            />

    )
}

export default CustomConfirmDialog;